import { Typography } from '@/ui';

import type { FC, ReactNode } from 'react';

interface MomentsCardProps {
  children: ReactNode;
  title: string;
}

const MomentsCard: FC<MomentsCardProps> = ({ children, title }) => (
  <section className="overflow-hidden rounded-2xl bg-sunny-100 shadow-lg">
    <Typography
      className="block px-8 py-5 font-medium text-cement-400"
      variant="caption"
    >
      {title}
    </Typography>
    {children}
  </section>
);

export default MomentsCard;
